import { ICompany } from "../core/models/company.model";
import { ITopCompanies } from "../core/models/results.model";
import { ICatalogueThemes } from "../core/models/thematic.model";

// app.state.ts
export interface Tab {
  tabId: string;
  search_type: string;
  params: Iparams|null;
  tab_name:string;
  sidenav_results: {
    [key: string]: any;
  };
  isLoading?: boolean; // Add tab-specific loading state
  universe?:IUniverseSelection;
}

export interface Iparams{
  entityids:string[] |null|undefined,
  query:string|null|undefined,
  gsubind:string[]|null;
  entity_data:ICompany|null|undefined;
  query_data:ICatalogueThemes|null|undefined;
  theme_search_type?: 'cluster' | 'custom' | null;
  cluster_id?: number | string | null;
  cluster_name?: string | null;
}

export interface MainState {
  activeTabId: string;
  activeSideTab: string;
  activeTab: Tab | null;
  // availableSidenavOptions: string[];
}

export interface AppState {
  main: MainState;
  TabList: Tab[];
}

// Always start with empty tabs - load from DB on app init
export const initialTabListState: Tab[] = [];

// Always start with empty main state - load from DB on app init
export const initialMainState: MainState = {
  activeTabId: '',
  activeSideTab: '',
  activeTab: null,
};
export const initialUniverseState: IUniverseSelection = {
    include_public:true,
    include_private:false,
}

export const initialState: AppState = {
  main: initialMainState,
  TabList: initialTabListState,
};


export interface IUniverseSelection{
  include_private:boolean,
  include_public:boolean,
  min_mcap?:number;
  max_mcap?:number;
}

export interface StoredTabData {
  tabId: string;
  search_type: string;
  params: Iparams | null;
  tab_name: string;
  universe?: IUniverseSelection;
}

export const companySideNavList:string[]=['executive_summary',
  'innov_metrics_history','innovation_activity_over_time',
  'company_private_competitors','company_public_competitors','competitive_benchmarking_peergroup',
  'company_technology_summary',
  'inventions_view',]
export const themeSideNavList:string[]=['thematic_exec_summary','thematic_performance_history','thematic_innovation_activity','thematic_public_competitors','thematic_private_competitors','thematic_custom_peer_group','thematic_technology_summary','inventions_view']
